define('views/wallet/wallet',[
	'backbone',
	'views/_base/baseview',
	'text!views/wallet/wallet.html',
	'models/accounts/rebatesummary',
	'models/merchants/giftcard_collection',
	'models/linkedcards/linkedcard_collection',
	'models/accounts/bank',
	'views/ecards/ecard_group',
	'views/wallet/pfdebit',
	'views/shared/modal/modal_modern',
	'views/transactions/transaction',
	'models/accounts/accounttransaction_collection',
	'models/accounts/accounttransactiondata',
	'models/accounts/accounttransaction',
	'models/accounts/accounts',
], function (
	Backbone,
	BaseView,
	Template,
	RebatesModel,
	EcardsModel,
	LinkedCardsModel,
	BankModel,
	EcardGroupView,
	PfdebitView,
	Modal,
	AccountTransactionView,
	AccountTransactionCollection,
	AccountTransactionDataModel,
	AccountTransactionModel,
	AccountsModel
) {
	'use strict';

	return BaseView.extend({
		id: 'account-container',
		tagName: 'div',
		isRender: true,
		needsAuth: true,
		template: _.template(Template),
		events: {
			'click .js-account-preview-next': 'showNextGroupMerchants',
			'click .js-account-preview-previous': 'showPreviousGroupMerchants',
			'click .js-account-pfdebit-learnmore-btn': 'showPfdebitForm',
			'click .js-account-welcome-cta-btn': 'goToLinkBank',
			'click .js-account-transactions-btn': 'goToTransactions',
			'click .js-account-direct-deposit': 'goToDirectDepositForm',
			'click #gc-toggle': 'toggleGC',
		},
		initialize: function (options) {
			options = options || {};

			this.grouped_ecards = {};
			this.spending_account = options.spending_account;
			this.bank = options.bank;
			this.bulk_reg_transfer = options.bulk_reg_transfer;
			this.show_debit_form = options.show_debit_form;

			// transaction config
			this.last_days_count = 7;
			this.collection_transaction_list = new AccountTransactionCollection();

			// Get CIP Status
			this.cip_status = checkCipStatus();

			// this.bulk_reg_transfer = true;
			this.elementName = options.elementName;

			pf.globalEvents.on(
				'reload_ecard_groups',
				_.bind(this.reloadEcardGroups, this)
			);

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this;

			if (!pf.IsConsumerFinancial) {
				// Carried over from accountsmain.js
				store.getStoreItem(
					enums.modelsEnum.EmailVerificationPassed,
					null,
					false,
					false,
					false,
					function (data) {
						that.EmailVerificationPassed = data;
					}
				);
				// Carried over from accountsmain.js
				store.setStoreItem(enums.modelsEnum.EmailVerificationPassed, {
					Data: 0,
				});

				var product = 'linkVisa';

				pf.controller.showMemberApplication(product, false);
			} else {
				this.$el.html(this.template());

				if (this.bulk_reg_transfer) {
					this.showWelcomeBanner();
				}

				if (this.show_debit_form) {
					this.showPfdebitForm();
				}
			}

			pf.wallet = this;

			return this;
		},

		loadData: function () {
			var that = this;

			pf.controller.loadAccounts(function () {
				that.getAllData();
			});

			// if(pf.accounts){
			//     this.getAllData();
			// } else {
			//     pf.controller.loadAccounts(this.getAllData);
			// }
		},

		getAllData: function () {
			this.showAccountInfo();
			this.showBalance();
			this.getRebates();
			this.getEcards();
			this.getRecentTransactions();
			this.getLinkedCards();
			this.getBankStatus();
			this.checkForPFDebitCard();
		},

		showWelcomeBanner: function () {
			this.$el.find('.account-container-top').addClass('banner');
			this.$el.find('#account-welcome-banner-container').show();
		},

		showAccountInfo: function () {
			var that = this;

			if (pf.accounts.spending_account) {
				var account = pf.accounts.spending_account,
					account_number = account.proxy_number,
					card_number = account.account_name.indexOf('Account')
						? account.account_name.slice(
								account.account_name.indexOf('Account') + 8
						  )
						: account.account_name;

				this.$el
					.find('.js-account-pf-details-account-number')
					.html(account_number);
				this.$el.find('.js-account-pf-details-card-number').html(card_number);
			} else {
				setTimeout(function () {
					that.showAccountInfo();
				}, 1000);
			}
		},

		showBalance: function () {
			var that = this;

			if (pf.accounts.spending_account) {
				var balance = formatBalanceCurrency(
					pf.accounts.spending_account.balance
				);
				this.$el.find('.js-account-pf-balance-amt').removeClass('loading');
				this.$el.find('.js-account-pf-balance-amt').html(balance);
			} else {
				setTimeout(function () {
					that.showBalance();
				}, 1000);
			}
		},

		getRebates: function () {
			var that = this;

			this.rebates_model = new RebatesModel({
				instanceURL: pf.consumerURL + '/Rebates',
				limit: 3,
			});
			this.rebates_model.fetch({
				success: function (model, resp) {
					that.addRebates();
				},
				error: function (err, a, b, c) {
					// TODO: Add error state here
				},
			});
		},

		addRebates: function () {
			var rebates = this.rebates_model.toJSON(),
				week = rebates.RebatesThisWeek
					? formatCurrency(rebates.RebatesThisWeek)
					: formatCurrency(0.0),
				month = rebates.RebatesThisMonth
					? formatCurrency(rebates.RebatesThisMonth)
					: formatCurrency(0.0),
				year = rebates.RebatesThisYear
					? formatCurrency(rebates.RebatesThisYear)
					: formatCurrency(0.0),
				total = rebates.TotalRebates
					? formatCurrency(rebates.TotalRebates)
					: formatCurrency(0.0);

			this.$('.js-rebate-cash-week').html(week);
			this.$('.js-rebate-cash-month').html(month);
			this.$('.js-rebate-cash-year').html(year);
			this.$('.js-rebate-cash-total').html(total);
		},

		loadEcards: function (callback) {
			if (_.isFunction(callback)) {
				callback();
			}
		},

		reloadEcardGroups: function (first_param) {
			this.$('.js-account-egiftcards').html('');
			delete this.ecards_model;
			this.getEcards();
		},

		getEcards: function (callback, that) {
			var that = that || this;

			this.grouped_ecards = {};

			this.ecards_model = new EcardsModel();

			this.ecards_model.fetch({
				success: function (model, resp) {
					// if(that.bulk_reg_transfer){
					//     that.showEcardBulkRegEmptyState();
					// } else {
					//     that.showEcardEmptyState();
					// }

					if (!callback) {
						if (model.length) {
							// TODO: Break logic out into another component
							that.groupEcards();
						} else {
							if (that.bulk_reg_transfer) {
								that.showEcardBulkRegEmptyState();
							} else {
								that.showEcardEmptyState();
							}
						}
					}

					if (_.isFunction(callback)) {
						var ecards = that.ecards_model.toJSON();

						callback(ecards);
					}
				},
				error: function () {
					// TODO: Show error state
				},
			});
		},

		showEcardEmptyState: function () {
			var html =
				'<li class="account-egiftcards-empty"><p>No eGift Cards to show</p></li>';
			this.$el.find('.js-account-egiftcards').html(html);
		},

		showEcardBulkRegEmptyState: function () {
			var html =
				'<li class="account-egiftcards-empty-bulkreg"><p>Use your wellness dollars to purchase eGift Cards</p><button class="btn btn-default btn--pill account-egiftcards-shop-btn js-account-egiftcards-shop-btn">Shop Now</button></li>';

			this.$el.find('.js-account-egiftcards').html(html);

			this.$el
				.find('.js-account-egiftcards-shop-btn')
				.on('click', this.goToShop);
		},

		goToShop: function () {
			pf.navigate('#shop');
		},

		groupEcards: function () {
			var ecards = this.ecards_model.toJSON();

			ecards.forEach(function (ecard) {
				if (this.grouped_ecards.hasOwnProperty(ecard.MerchantGroupGUID)) {
					this.grouped_ecards[ecard.MerchantGroupGUID].push(ecard);
				} else {
					this.grouped_ecards[ecard.MerchantGroupGUID] = [];
					this.grouped_ecards[ecard.MerchantGroupGUID].push(ecard);
				}
			}, this);

			this.createEcardGroupList();
		},

		createEcardGroupList: function () {
			var group_count = 0;

			for (var key in this.grouped_ecards) {
				var ecards = this.grouped_ecards[key],
					num = ecards.length,
					name = ecards[0].GroupName,
					// logo = ecards[0].GiftCardImagelarge;
					logo = ecards[0].GroupLogo;

				var ecard_group = new EcardGroupView({
					data: { key: key, logo: logo, name: name, num: num, ecards: ecards },
					header: true,
					wallet: true,
					loadEcards: this.getEcards,
					wallet_view: this,
				});
				this.$('.js-account-egiftcards').append(ecard_group.el);

				group_count++;
			}

			if (group_count >= 4) {
				this.enableCarousel();
			}
		},

		enableCarousel: function () {
			this.$el.find('.js-account-preview-next').addClass('show');
		},

		showNextGroupMerchants: function () {
			this.animateList('next');
		},

		showPreviousGroupMerchants: function () {
			this.animateList('previous');
		},

		resetPreview: function () {
			this.$el.find('.js-account-egiftcards').css({ marginLeft: '0px' });
			this.$el.find('.js-account-preview-previous').removeClass('show');
			this.$el.find('.js-account-preview-next').addClass('show');
		},

		animateList: function (direction) {
			var list = this.$el.find('.js-account-egiftcards'),
				list_container = this.$el.find('#account-egiftcard-list-container'),
				next_btn = list_container.find('.js-account-preview-next'),
				previous_btn = list_container.find('.js-account-preview-previous'),
				preview_width = list_container.width(),
				list_width =
					(list.children().eq(0).width() + 8) * list.children().length,
				current_offset = Math.abs(parseInt(list.css('marginLeft'))),
				offset =
					direction == 'next'
						? preview_width + current_offset
						: current_offset - preview_width;

			if (
				(direction == 'next' && offset <= list_width) ||
				(direction == 'previous' && offset >= 0)
			) {
				list.animate({ marginLeft: '-' + offset + 'px' }, this.animate_time);

				if (offset + preview_width > list_width) {
					next_btn.removeClass('show');
				} else if (offset + preview_width <= list_width) {
					next_btn.addClass('show');
				}

				if (offset > 0) {
					previous_btn.addClass('show');
				} else if (offset - preview_width < 0) {
					previous_btn.removeClass('show');
				}
			}
		},

		getRecentTransactions: function () {
			var that = this;

			if (pf.accounts.spending_account) {
				var account_id = pf.accounts.spending_account.account_id;

				var ed = new Date();
				var sd = new Date();

				sd.setDate(sd.getDate() - that.last_days_count);

				var startdate =
					sd.getMonth() + 1 + '/' + sd.getDate() + '/' + sd.getFullYear();
				var enddate =
					ed.getMonth() + 1 + '/' + ed.getDate() + '/' + ed.getFullYear();

				var date_string = '&startdate=' + startdate + '&enddate=' + enddate;

				var account_transaction_data_model = new AccountTransactionDataModel();

				account_transaction_data_model
					.fetch({
						url:
							pf.consumerURL +
							'/Accounts/TX/' +
							account_id +
							'?pn=1' +
							date_string +
							'&periodType=2',
					})
					.done(function (response) {
						that.collection_transaction_list =
							account_transaction_data_model.attributes.transaction_list;
						that.$('.loading-transactions').remove();
						that.showRecentTransactions();
						that.addAllTransactions();
					})
					.fail(function (err) {
						// console.error(err);
					});
			} else {
				setTimeout(function () {
					that.getRecentTransactions();
				}, 1000);
			}
		},

		addAllTransactions: function () {
			var that = this;

			if (that.collection_transaction_list.length > 0) {
				that.collection_transaction_list.length = 5;
				that.collection_transaction_list.forEach(that.addOneTransaction, that);
			} else {
				// show empty state
				that.showTransactionsEmptyState();
			}
		},

		addOneTransaction: function (account_transaction) {
			var transaction = new AccountTransactionModel(account_transaction);
			var transaction_view = new AccountTransactionView({ model: transaction });
			this.$('.js-account-transactions').append(transaction_view.el);
		},

		showTransactionsEmptyState: function () {
			this.$el.find('.js-account-transactions-empty').show();
			// this.$el.find('.js-account-transactions-btn').hide();
		},

		showRecentTransactions: function () {
			this.$el.find('.js-account-transactions').show();
			this.$el.find('.js-account-transactions-btn').css({ display: 'block' });
		},

		getLinkedCards: function () {
			var that = this;

			this.linked_cards = new LinkedCardsModel({
				instanceURL: pf.consumerURL + '/LinkedCards?smc=true',
			});
			this.linked_cards.fetch({
				success: function (model, resp) {
					if (that.linked_cards.length) {
						that.showLinkedCardCount();
					} else {
						that.showNoLinkedCardMsg();
					}
				},
				error: function () {
					// TODO: Empy error state
				},
			});
		},

		showLinkedCardCount: function () {
			this.$el
				.find('.js-linked-cards-count-number')
				.html(this.linked_cards.length);
			this.$el.find('.js-linked-cards-count').css({ display: 'block' });
		},

		showNoLinkedCardMsg: function () {
			this.$el.find('.js-linked-cards-count').hide();
			this.$el
				.find('.js-account-linked-accounts-cards-btn')
				.css({ display: 'block' });
		},

		getBankStatus: function () {
			var that = this;

			this.bank = new BankModel();
			this.bank.fetch({
				success: function (model, resp) {
					var data = that.bank.toJSON();

					if (resp) {
						that.showBankInfo();
					} else {
						that.showBankEmptyState();
					}
				},
				error: function (err, a) {
					// console.log('getBankStatus error',err,a);
					// TODO: Show error state
				},
			});
		},

		showBankEmptyState: function () {
			$('.js-account-link-bank').css({ display: 'block' });
		},

		showUnverifiedBank: function () {
			$('.js-account-verify-bank').css({ display: 'block' });
		},

		showBankAccount: function () {
			var data = this.bank.toJSON();
			this.$el.find('.js-bank-account-name').html(data.account_name);
			this.$el.find('.js-account-bank').css({ display: 'block' });
		},

		showBankInfo: function () {
			var data = this.bank.toJSON();

			if (
				data.verification_status == 'undefined' ||
				data.verification_status == '0'
			) {
				/* No linked bank account */
				this.showBankEmptyState();
			} else if (data.verification_status != '2') {
				/* Has linked bank account but hasn't verified, if it is equal to 2 then the bank account has been verified */
				this.showUnverifiedBank();
			} else {
				this.showBankAccount();
			}
		},

		checkForPFDebitCard: function () {
			// if(pf.session.get('CardType') == enums.cardTypes.GPRDebitCard) {
			if (pf.session.get('CardType') != enums.cardTypes.GPRDebitCard) {
				this.$el.find('.js-account-linked-accounts-pfdebit').show();
			}
		},

		showPfdebitForm: function () {
			if (isSunsetting()) {
				return;
			}

			this.cip_status = checkCipStatus();

			if (this.cip_status && pf.IsConsumerFinancial) {
				var pfdebit_form_view = new PfdebitView(),
					modal = new Modal({
						show: true,
						content: pfdebit_form_view.$el.html(),
						calling_view: pfdebit_form_view,
					});
			} else {
				goToFinancialRegistration('wallet/debit');
			}
		},

		goToLinkBank: function () {
			pf.navigate('#linkedaccounts');
		},

		goToTransactions: function (e) {
			e.preventDefault();
			pf.navigate('transactions');
		},

		goToDirectDepositForm: function (e) {
			if (isSunsetting()) {
				e.preventDefault();
				return;
			}
			window.open('#directdeposit', '_blank');
		},

		toggleGC: function (e) {
			if (e) {
				e.preventDefault();
			}

			var target = $(e.currentTarget),
				toggleText = $('#toggle-text'),
				content = target.prev();

			target.toggleClass('active');

			toggleText.text((index, text) =>
				text === 'view details' ? 'hide details' : 'view details'
			);

			content.css(
				'maxHeight',
				parseInt(content.css('maxHeight'), 10)
					? 0
					: content.get(0).scrollHeight + 'px'
			);
		},

		close: function () {
			// console.log('closing Wallet');
		},
	});
});

